<template>
    <SboIcon
        v-bind:name="sboIconName"
        v-bind:size="size"
    />
</template>

<script lang="ts" setup>
    import type { IconName } from '@sbo/icons-vue';
    import type { PropType } from 'vue';
    import { computed } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { SportType } from '@/interface/enum';
    import { invertCapitalize } from '@/libraries/string';

    const props = defineProps({
        sportType: {
            type: Number as PropType<SportType>,
            required: true,
        },
        colorful: {
            type: Boolean,
            required: false,
        },
        size: {
            type: [Number, String],
            default: () => 'default',
        },
    });

    const sboIconName = computed(() => {
        const sportName = invertCapitalize(SportType[props.sportType]);
        const style = props.colorful ? 'Color' : '';
        return `sports:${sportName}${style}` as IconName;
    });
</script>
